import React from "react";
import { getOrigin } from "utils/method";
import { buildSeoPagePath } from "utils/seoPath";
import { getOgImageUrl, OG_IMAGE_WIDTH, OG_IMAGE_HEIGHT, OG_IMAGE_MIME } from "utils/ogImageUrl";

export default function Social({ title, description, resolvedUrl, locale, basePath }) {
  const origin = getOrigin("www");
  const pagePath = buildSeoPagePath(locale, resolvedUrl, basePath);
  const url = `${origin}${pagePath}`;
  const imageUrl = getOgImageUrl(origin);

  const ogTitle = title || "Spikex";
  const ogDescription = description || "Spikex";

  return (
    <>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Spikexofficial" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDescription} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:src" content={imageUrl} />
      <meta name="twitter:image:alt" content={ogTitle} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Spikex" />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:image:alt" content={ogTitle} />
      <meta property="og:image:type" content={OG_IMAGE_MIME} />
      <meta property="og:image:width" content={String(OG_IMAGE_WIDTH)} />
      <meta property="og:image:height" content={String(OG_IMAGE_HEIGHT)} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:locale:alternate" content="ja_JP" />
      <meta property="og:locale:alternate" content="hi_IN" />
      <meta property="og:locale:alternate" content="id_ID" />
      <meta property="og:locale:alternate" content="ru_RU" />
      <meta property="og:locale:alternate" content="es_ES" />
      <meta property="og:locale:alternate" content="vi_VN" />
      <meta property="og:locale:alternate" content="th_TH" />
      <meta property="og:locale:alternate" content="zh_CN" />
      <meta property="og:locale:alternate" content="zh_HK" />
    </>
  );
}
